<span *ngIf="!isSamplingSupply || (isSamplingSupply && !isFree); else freeSamplingSupplyPrice">
  {{ cartItem.quantityPrice?.amount | currency:'NZD':'symbol-narrow'}}
</span>
<ng-template #freeSamplingSupplyPrice>
  <span>Free Kit</span>
</ng-template>
